/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkContactOrganizationRequest
 */
export interface LinkContactOrganizationRequest {
    /**
     * 
     * @type {number}
     * @memberof LinkContactOrganizationRequest
     */
    organizationId: number;
    /**
     * 
     * @type {string}
     * @memberof LinkContactOrganizationRequest
     */
    role?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LinkContactOrganizationRequest
     */
    isPrimary?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LinkContactOrganizationRequest
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the LinkContactOrganizationRequest interface.
 */
export function instanceOfLinkContactOrganizationRequest(value: object): value is LinkContactOrganizationRequest {
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    return true;
}

export function LinkContactOrganizationRequestFromJSON(json: any): LinkContactOrganizationRequest {
    return LinkContactOrganizationRequestFromJSONTyped(json, false);
}

export function LinkContactOrganizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkContactOrganizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationId': json['organizationId'],
        'role': json['role'] == null ? undefined : json['role'],
        'isPrimary': json['isPrimary'] == null ? undefined : json['isPrimary'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function LinkContactOrganizationRequestToJSON(json: any): LinkContactOrganizationRequest {
    return LinkContactOrganizationRequestToJSONTyped(json, false);
}

export function LinkContactOrganizationRequestToJSONTyped(value?: LinkContactOrganizationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organizationId': value['organizationId'],
        'role': value['role'],
        'isPrimary': value['isPrimary'],
        'notes': value['notes'],
    };
}

